import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { WeavyChatService } from '../weavy-chat.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {

  public displayName = '';
  currentUser: any;

  constructor(private weavyService: WeavyChatService, private route: ActivatedRoute, private loadingCtrl: LoadingController) { }

  ngOnInit() {
    this.showLoader();
    this.currentUser = JSON.parse(localStorage.getItem('pToken'));
    this.route.params.subscribe(params => {
      let app;
      if (params.roomId) {
        this.weavyService.getConversationById(params.roomId).then(async (response)=>{
          let data = await response.json();
          app = this.weavyService.openChat(data.uid);
          document.getElementById('chatcontainer').append(app);       
          this.displayName = this.getDisplayName(data);
          this.hideLoader();
          // app.whenBuilt().then(()=>{
          //   app.panel.maximize();
          //   let element = app.root.container.querySelector('.wy-controls');
          //   element.innerHTML = this.getCustomHeader();
          //   this.hideLoader();
          // });
        });
      }
    });

  }

  getDisplayName(conversation){
    if(conversation.uid.includes('promoga_chat_room')){
      return conversation['display_name'];
    }
    let userIds = conversation.uid.replace('promoga_chat_dm_','').split('_');
    let userNames = conversation.display_name.split(',');
    if(userIds && userIds.length == 2 && userNames && userNames.length == 2){
       userIds.map((userId, index)=>{
          if(this.currentUser && this.currentUser.user && this.currentUser.user.id != userId){
             conversation['display_name'] = userNames[index];
          }
       });
    }
    return conversation['display_name'];
  }

  showLoader() {
    this.loadingCtrl.create({
        message: 'Loading...'
    }).then((res) => {
        res.present();

        res.onDidDismiss().then((dis) => {
            this.hideLoader();
        });
    });
}

hideLoader() {
    setTimeout(() => {
        this.loadingCtrl.dismiss();
    }, 1000);
}
}
